import { NgModule } from '@angular/core';
import { S146gS146m01Component } from './s146g-s146m01.component';
import { S146gS146m02Component } from './s146g-s146m02.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S146gS146m01Component,
		S146gS146m02Component]
})
export class S146gModule { }

